import { createFileRoute } from '@tanstack/react-router';
import { requireAnyPermission } from '@/lib/route-guards/permission-guard';
import { OrderStageSettingsPage } from '@/pages/crm/settings/pipelines/order-stages/OrderStageSettingsPage';

export const Route = createFileRoute('/_authenticated/_app/crm/settings/order-pipeline')({
	beforeLoad: ({ context }) =>
		requireAnyPermission({ context, anyOf: ['orders.configurePipeline'], redirectTo: '/dashboard' }),
	component: OrderStageSettingsPage,
});
